<template>
    <v-container>
        <v-card>
            <v-card-title class="yellow"><span class="white--text">Success</span></v-card-title>
            <v-card-text>
                You are now logged out.
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    export default {
        name: 'logout',

        computed: {
            loggedIn: function () {
                return this.$store.state.loggedIn
            }
        },
        mounted() {
            if (this.loggedIn) this.$router.push("/")
        }
    }
</script>
